// Per-provider DME product deny-list helpers. The manufacturer pushes the list
// onto the provider org (DoctorOffice.dmeProductRestrictions.disabledProducts)
// and the order form reads it from auth.orgInfo. Keys are the exact strings the
// order stores — primary products from "Get Products", secondary keys from
// orderEnums.js — so one Set covers both kinds.

export const PRODUCT_RESTRICTED = "product_restricted";

export function toProductSet(value) {
  if (value instanceof Set) return value;
  const set = new Set();
  if (Array.isArray(value)) {
    for (const item of value) {
      if (typeof item === "string" && item) set.add(item);
    }
  }
  return set;
}

export function getDisabledProductSet(orgInfo) {
  return toProductSet(orgInfo?.dmeProductRestrictions?.disabledProducts);
}

export function isProductDisabled(set, key) {
  return !!set && typeof set.has === "function" && typeof key === "string" && set.has(key);
}

export function filterAllowedProducts(list, set) {
  if (!Array.isArray(list)) return [];
  if (!set || set.size === 0) return list;
  return list.filter((p) => !isProductDisabled(set, p));
}

// Backend block idiom (same shape as the required-documents lock):
// { blocked: true, errorCode: "product_restricted", errorMessage, restrictedProducts } and no order.
export function isProductRestrictedOutput(output) {
  return !!output && output.blocked === true && output.errorCode === PRODUCT_RESTRICTED;
}

export function makeProductRestrictedError(output) {
  const err = new Error(PRODUCT_RESTRICTED);
  err.code = PRODUCT_RESTRICTED;
  err.blockedMessage = (output && output.errorMessage) || null;
  err.restrictedProducts = Array.isArray(output?.restrictedProducts) ? output.restrictedProducts : [];
  return err;
}

export function isProductRestrictedError(err) {
  return !!err && err.code === PRODUCT_RESTRICTED;
}

export function formatRestrictedProductsMessage(t, restrictedProducts) {
  const head = t("orders.productRestrictions.submitBlocked");
  const items = (Array.isArray(restrictedProducts) ? restrictedProducts : [])
    .filter((r) => r && typeof r.product === "string")
    .map((r) => t("orders.productRestrictions.submitBlockedItem", { wound: r.wound, product: r.product }));
  return items.length ? `${head} ${items.join("; ")}` : head;
}
